import { Inject, Injectable, Injector } from "@angular/core";
import { BigNumber } from 'bignumber.js';
import moment from 'moment';
import { NumberFormat, UserSettings, UserSettingsToken } from "@farris/devkit";

@Injectable()
export class LocalizationService {
  constructor(private injector: Injector, @Inject(UserSettingsToken) private userSettings: UserSettings) { }

  /**
   * ç¨æ·éç½®æ ¼å¼
   */
  public get formats(): { date: { dateFormat: string, timeFormat: string, dateTimeFormat: string }, number: { negativeSign: string, numberDecimalDigits: number, numberDecimalSeparator: string, numberGroupSeparator: string }, [prop: string]: any } {
    const { dateFormat = null, timeFormat = null } = this.userSettings || {};
    let dateTimeFormat = null;
    if (dateFormat && timeFormat) {
      dateTimeFormat = `${dateFormat} ${timeFormat}`;
    }
    const date = {
      dateFormat,
      timeFormat,
      dateTimeFormat
    };
    const { negativeSign = null, numberDecimalDigits = null, numberDecimalSeparator = null, numberGroupSeparator = null } = this.numberFormat || {};
    const number = {
      negativeSign,
      numberDecimalDigits,
      numberDecimalSeparator,
      numberGroupSeparator
    };
    return { date, number };
  }
  /**
   * æ ¹æ®æ°æ®ç±»åæ¬å°åæ°æ®
   * @param value value
   * @param dataType æ°æ®ç±»å
   * @returns string
   */
  public localize(value: any, dataType: string): string {
    if (dataType && value) {
      dataType = dataType.toLowerCase();
      if (dataType === 'date') {
        return this.transformDate(value);
      } else if (dataType === 'datetime') {
        return this.transformDateTime(value);
      } else if (dataType === 'number') {
        return this.transformNumber(value);
      } else {
        return value;
      }
    } else {
      return value;
    }
  }
  /**
   * æ ¹æ®å½éåç±»åè·åæ ¼å¼åå­ç¬¦ä¸²
   * @param localizationType å½éåç±»å
   * @returns 
   */
  public getFormat(localizationType: string): string {
    if (localizationType) {
      localizationType = localizationType.toLowerCase();
    }
    if (localizationType === 'date') {
      return this.formats.date.dateFormat;
    } else if (localizationType === 'datetime') {
      return this.formats.date.dateTimeFormat;
    } else {
      return '';
    }
  }
  /**
   * è½¬æ¢æ¥æ
   * @param value value
   */
  private transformDate(value: any) {
    let dateFormat = this.userSettings && this.userSettings.dateFormat || 'YYYY-MM-DD';
    if (!dateFormat || !value) {
      return value;
    }
    const date = moment(value);
    const isValid = date.isValid();
    if (!isValid) {
      return value;
    }
    dateFormat = this.parseDateFormat(dateFormat);
    return date.format(dateFormat);
  }
  /**
   * è½¬æ¢æ¥ææ¶é´
   * @param value value
   * todo: ç®åæ æ³å®ä¹æ¥ææ¶é´æ ¼å¼
   */
  private transformDateTime(value: any) {
    let dateFormat = this.userSettings && this.userSettings.dateFormat || 'YYYY-MM-DD';
    let timeFormat = this.userSettings && this.userSettings.timeFormat || 'HH:mm:ss';
    if (!dateFormat || !timeFormat) {
      return value;
    }
    const dateTime = moment(value);
    const isValid = dateTime.isValid();
    if (!isValid) {
      return value;
    }
    if (dateFormat) {
      dateFormat = this.parseDateFormat(dateFormat);
    }
    if (timeFormat) {
      timeFormat = this.parseTimeFormat(timeFormat);
    }
    const dateTimeFormat = dateFormat + ' ' + timeFormat;
    return dateTime.format(dateTimeFormat);
  }
  /**
   * è½¬æ¢æ°å­
   * @param value value
   */
  private transformNumber(value): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const bigNumber = new BigNumber(value);
    // å¦æä¸æ¯æ°å­ï¼ä¸åä»»ä½å¤ç
    if (!BigNumber.isBigNumber(bigNumber)) {
      return value;
    }
    const isNegative = bigNumber.isNegative();
    const format = this.buildNumberFormat();
    const { negativeSign = null, numberDecimalDigits = null } = this.numberFormat || {};
    if (isNegative) {
      if (negativeSign !== null) {
        format.prefix = negativeSign;
        return bigNumber.absoluteValue().toFormat(numberDecimalDigits, null, format);
      }
    }
    return bigNumber.toFormat(numberDecimalDigits, null, format);
  }
  /**
   * è½¬æ¢æ¥ææ ¼å¼è§åä¸ºmomentçformatè§å
   * @param format format
   */
  private parseDateFormat(format: string) {
    return format.replace(/y/g, 'Y').replace(/d/g, 'D');
  }
  /**
   * è½¬æ¢æ¶é´æ ¼å¼è§åä¸ºmomentçformatè§å
   * @param format format
   */
  private parseTimeFormat(format: string) {
    return format.replace(/M/g, 'm');
  }
  /**
   * æé bignumberæ°å­æ ¼å¼åéé¡¹
   */
  private buildNumberFormat() {
    if (this.numberFormat) {
      const { numberDecimalSeparator = null, numberGroupSeparator = null } = this.numberFormat;
      const format: any = {
        groupSize: 3,
      };
      if (numberDecimalSeparator !== null) {
        format.decimalSeparator = numberDecimalSeparator;
      }
      if (numberGroupSeparator !== null) {
        format.groupSeparator = numberGroupSeparator;
      }
      return format;
    }
  }
  private get numberFormat(): NumberFormat {
    return this.userSettings && this.userSettings.numberFormat || null;
  }
}